import React, {Component} from 'react';
import './GeneralCheckQuestion.css';
import Button from "../button/Button";
import ProgressBar from "../pages/scanner/progressBar/ProgressBar";
import Card from "../card/Card";
import Label from "../label/Label";
import PrimaryButton from "../primaryButton/PrimaryButton";
import Icon from "../icon/Icon";
import TertiaryButton from "../tertiaryButton/TertiaryButton";
import generalChecksModel from "../../model/GeneralChecksModel";
import ImageInput from "../imageInput/ImageInput";
import toasts from "../../utils/toasts";

export default class GeneralCheckQuestion extends Component {
	constructor() {
		super();
		this.state = {
			open: false,
			checks: [],
			currentCheckIndex: 0,
			category: null
		}
	}

	close = () => {
		this.setState({open: false})
	};
	open = (categoryId) => {
		this.update(categoryId);
	}
	update = (categoryId) => {
		const category = generalChecksModel.getCategory(categoryId);
		const checks = generalChecksModel.getChecksInCategory(categoryId);
		this.setState({open: true, category,categoryId, checks, currentCheckIndex: 0});
	};

	currentCheck = () => {
	   return this.state.checks[this.state.currentCheckIndex];
	};

	answerYes = () => {
		const currentCheck = this.currentCheck();
		const check = generalChecksModel.getCheck(currentCheck.general_check_question_id)
		generalChecksModel.updateCheck(check.general_check_question_id, {...check, completed:true, passed:true})
		this.update(this.state.categoryId)
		this.next();
	};
	imageChange = (image_url) => {
		const currentCheck = this.currentCheck();
		const check = generalChecksModel.getCheck(currentCheck.general_check_question_id)
		generalChecksModel.updateCheck(check.general_check_question_id, {...check, image_url})
		this.update(this.state.categoryId)
	};
	answerNo = () => {
		const currentCheck = this.currentCheck();
		const check = generalChecksModel.getCheck(currentCheck.general_check_question_id)
		generalChecksModel.updateCheck(check.general_check_question_id, {...check, completed:true, passed:false})
		this.update(this.state.categoryId)
		toasts.show('Upload an image or skip');
		// this.next();
	};

	next = () => {
		if(this.state.currentCheckIndex === this.state.checks.length - 1){
			this.close();
		}
		this.setState({currentCheckIndex: this.state.currentCheckIndex + 1})
	}
	previous = () => {
		this.setState({currentCheckIndex: this.state.currentCheckIndex - 1})
	}

	render() {
		const currentCheck = this.currentCheck();

		let checkName = '';
		if (this.state.checks[this.state.currentCheckIndex]) {
			checkName = this.state.checks[this.state.currentCheckIndex].general_check_question_name;
		}

		return (
			<div className={"g-general-check-question " + (this.state.open ? 'open' : 'closed')}>
				<div className='background' onClick={this.close}></div>
				<div className='main-card'>
					<div className={'next-prev-btns'}>
						<Button disabled={!this.state.currentCheckIndex} onClick={this.previous}><Icon name="arrow-left"/></Button>
						{currentCheck && currentCheck.passed === false && <ImageInput folder={'general-check'} onChange={this.imageChange}/>}
						<Button disabled={this.state.currentCheckIndex === this.state.checks.length - 1} onClick={this.next}><Icon name="arrow-left right"/></Button>
					</div>
					<ProgressBar progress={generalChecksModel.categoryProgress(this.state.categoryId)} total={generalChecksModel.categoryTotal(this.state.categoryId)}/>
					<Card className={'question'}>
						<Label center large dark bold>{checkName}</Label>
						<br/>
						<Label center large dark>Operational?</Label>
					</Card>
					<div className={'pass-fail-btns'}>
						<TertiaryButton className={currentCheck?.passed === false && 'outline'} onClick={this.answerNo}>No</TertiaryButton>
						<PrimaryButton className={currentCheck?.passed === true && 'outline'} onClick={this.answerYes}>Yes</PrimaryButton>
					</div>
				</div>
			</div>
		)
	}
}